import { useEffect, useState } from 'react';
import { InfoIcon } from '@shared/assets/index.ts';
import { useAppDispatch } from '@shared/hooks/index.ts';
import { FormFieldWithLabelAndCard } from '@shared/ui/forms/FieldWithLabel/index.ts';
import { Toggle } from '@shared/ui/index.ts';
import { openNotifyModal } from '@src/library/redux/modal/index.ts';
import * as st from './styles.module.scss';

type PT = {
  initData?: boolean;
  onChange: (value: boolean) => void;
};

export const FormCommentsField = ({ onChange, initData }: PT) => {
  const dispatch = useAppDispatch();
  const [val, setVal] = useState(initData || false);
  useEffect(() => onChange(val), [onChange, val]);
  const onIconClick = () => {
    dispatch(
      openNotifyModal({
        title: 'Комментарии',
        text: `Функция "Комментарии" дает возможность пользователю оставить своё мнение о просмотренной видеопрограмме`,
        confirmText: 'Понятно',
        fullWidthText: true,
      })
    );
  };

  return (
    <FormFieldWithLabelAndCard
      fieldLabel={'Комментарии'}
      labelHelpersClassName={st.icon}
      labelWrapperClassName={st.labelWrapper}
      className={st.card}
      labelChildren={<InfoIcon onClick={onIconClick} />}
    >
      <p className={st.text}>{val ? 'Включены' : 'Отключены'}</p>
      <Toggle value={val} onToggle={(value) => setVal(value)} />
    </FormFieldWithLabelAndCard>
  );
};
